export type CategoryNames = {
  name: string;
  short_name: string;
};

type SearchTitleArgs = {
  key: string;
  interpolationOptions: {
    category?: string;
    first?: string;
    second?: string;
    third?: string;
  };
};

const getSearchTitleTranslationArgs = (
  categories: CategoryNames[],
  hasGeometry: boolean,
): SearchTitleArgs => {
  if (categories.length === 1) {
    return { key: 'search-title--single-category', interpolationOptions: { category: categories[0].name } };
  }
  if (categories.length > 1) {
    const [first, second, third] = categories.slice(0, 3).map((c) => c.short_name);
    if (categories.length === 2) {
      return { key: 'search-title--2-categories', interpolationOptions: { first, second } };
    }
    if (categories.length === 3) {
      return { key: 'search-title--3-categories', interpolationOptions: { first, second, third } };
    }
    return { key: 'search-title--over-3-categories', interpolationOptions: { first, second, third } };
  }
  if (hasGeometry) {
    return { key: 'search-title--geometry', interpolationOptions: {} };
  }
  return { key: 'search-title--default', interpolationOptions: {} };
};

export default getSearchTitleTranslationArgs;
